import { __extends } from "tslib";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
import { CreateMapRequest, CreateMapResponse } from "../models/models_0";
import { deserializeAws_restJson1CreateMapCommand, serializeAws_restJson1CreateMapCommand, } from "../protocols/Aws_restJson1";
var CreateMapCommand = (function (_super) {
    __extends(CreateMapCommand, _super);
    function CreateMapCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    CreateMapCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "LocationClient";
        var commandName = "CreateMapCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: CreateMapRequest.filterSensitiveLog,
            outputFilterSensitiveLog: CreateMapResponse.filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    CreateMapCommand.prototype.serialize = function (input, context) {
        return serializeAws_restJson1CreateMapCommand(input, context);
    };
    CreateMapCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restJson1CreateMapCommand(output, context);
    };
    return CreateMapCommand;
}($Command));
export { CreateMapCommand };
